import dynamic from "next/dynamic";
import React from "react";

function NoSSR(props: any) {
    return <React.Fragment>{props.children}</React.Fragment>;
}

export default dynamic(() => Promise.resolve(NoSSR), {
    ssr: false,
});